import { atom } from 'jotai';
import { fetchStations } from '../fetchStations';
import { mergeStations } from '../model/cache';
import type { LatestQuery } from '../model/synoptic';
import { loadStatusAtom, selectedStationIdAtom, stationCacheAtom } from './atoms';

/** Controller of the request in flight; a new one supersedes it. */
const requestAtom = atom<AbortController | null>(null);

/** Loads the stations of an area into the cache. */
export const loadStationsAtom = atom(null, async (get, set, query: Omit<LatestQuery, 'token'>) => {
  get(requestAtom)?.abort();
  const request = new AbortController();
  set(requestAtom, request);
  set(loadStatusAtom, { kind: 'loading' });
  try {
    const stations = await fetchStations(query, request.signal);
    set(stationCacheAtom, (cache) => mergeStations(cache, stations, Date.now()));
    set(loadStatusAtom, { kind: 'idle' });
  } catch (error) {
    if (request.signal.aborted) return;
    console.error(error);
    set(loadStatusAtom, { kind: 'error', error });
  }
});

/** Stops loading and closes the details, e.g. when the layer is hidden. */
export const cancelStationsAtom = atom(null, (get, set) => {
  get(requestAtom)?.abort();
  set(requestAtom, null);
  set(loadStatusAtom, { kind: 'idle' });
  set(selectedStationIdAtom, null);
});
